import RectificationRepository from '@/domain/repositories/RectificationRepository';
import RectificationNotesStore from '../datastores/RectificationNotesStore';
import RectificationNotesFactory from '../factories/RectificationNotesFactory';

export default class RectificationNotesDataRepository
  implements RectificationRepository
{
  getEvaluationsToBeCorrected(courseId: string, catalog: string) {
    const rectificationStore: RectificationNotesStore =
      RectificationNotesFactory.create();
    return rectificationStore.getEvaluationsToBeCorrected(courseId, catalog);
  }

  RegisterRectificationOfGrade(RectificationRegisterRequest: any) {
    const rectificationStore: RectificationNotesStore =
      RectificationNotesFactory.create();
    return rectificationStore.RegisterRectificationOfGrade(
      RectificationRegisterRequest
    );
  }
}
